import { PASSO_ESCADA_LABEL, PassoEscada } from "../types";

/**
 * Seletor da escada de aproximação (componente central do app).
 * 10 passos (0–9). Tocar um passo seleciona — e todos os passos abaixo dele
 * "enchem" em verde suave, comunicando progresso (não nota). Alvos grandes.
 */
const PASSOS = Object.values(PassoEscada).filter(
  (v): v is PassoEscada => typeof v === "number",
);

export function EscadaSelector({
  valor,
  onChange,
}: {
  valor: PassoEscada | null;
  onChange: (p: PassoEscada) => void;
}) {
  return (
    <div className="escada" role="radiogroup" aria-label="passo na escada de aproximação">
      {PASSOS.map((p) => {
        const preenchido = valor !== null && p <= valor;
        const atual = valor === p;
        return (
          <button
            key={p}
            type="button"
            role="radio"
            aria-checked={atual}
            className={`escada-passo${preenchido ? " preenchido" : ""}${atual ? " atual" : ""}`}
            onClick={() => onChange(p)}
          >
            <span className="num" aria-hidden>
              {p}
            </span>
            <span>{PASSO_ESCADA_LABEL[p]}</span>
          </button>
        );
      })}
    </div>
  );
}
